import { useNavigate, useLocation } from 'react-router-dom';
import { C } from '../constants';

const NAV_LINKS = [
  { label: 'How It Works',      path: '/how-it-works' },
  { label: 'Election Calendar', path: '/election-calendar' },
  { label: 'Blog',              path: '/blog' },
  { label: 'FAQ',               path: '/faq' },
  { label: 'About',             path: '/about' },
  { label: 'Contact',           path: '/contact' },
];

/**
 * Shared site header used by every layout wrapper.
 *
 * Props:
 *   subtitle   – small text after the brand name (e.g. "— Tamil Nadu")
 *   right      – JSX rendered after the nav links (Switch State pill,
 *                countdown, Vote Now button, etc.)
 */
export default function SiteHeader({ subtitle, right }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header
      className="px-5 md:px-10 py-4 flex items-center justify-between gap-4 flex-wrap relative z-10"
      style={{
        borderBottom:         `1px solid ${C.border}`,
        background:           'rgba(13,13,26,0.7)',
        backdropFilter:       'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      {/* Logo */}
      <div
        className="flex items-center gap-3 cursor-pointer min-w-0"
        onClick={() => navigate('/')}
      >
        <img
          src="/ue-logo.jpg"
          alt="UE Logo"
          style={{ width: 36, height: 36, borderRadius: 8, flexShrink: 0, objectFit: 'cover' }}
        />
        <div className="min-w-0">
          <div className="flex items-baseline gap-2 flex-wrap">
            <span style={{ fontWeight: 700, fontSize: '1.05rem', lineHeight: 1.1, color: C.white, letterSpacing: '-0.01em' }}>
              Unofficial<span style={{ color: '#F97316' }}>Election</span>
            </span>
            {subtitle && (
              <span style={{ fontWeight: 500, fontSize: '0.78rem', color: C.textDim, lineHeight: 1.1 }}>
                {subtitle}
              </span>
            )}
          </div>
          <div style={{
            fontSize: '0.72rem', lineHeight: 1.2, marginTop: 2,
            background: `linear-gradient(90deg, ${C.cyan}, ${C.pink})`,
            WebkitBackgroundClip: 'text', backgroundClip: 'text',
            color: 'transparent', fontWeight: 600, letterSpacing: '0.02em',
          }}>
            unofficialelections.com
          </div>
        </div>
      </div>

      {/* Nav + right slot */}
      <div className="flex items-center gap-2">
        {/* Nav links — hidden on mobile, visible md+ */}
        <div className="hidden md:flex items-center gap-2">
          {NAV_LINKS.map(({ label, path }) => {
            const active = pathname === path || pathname.startsWith(path + '/');
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                style={{
                  background:  active ? 'rgba(0,229,255,0.08)' : 'none',
                  border:      `1px solid ${active ? C.cyan : C.border}`,
                  padding:     '5px 13px', borderRadius: 999, fontSize: '0.73rem',
                  fontWeight:  600, color: active ? C.cyan : C.textDim, cursor: 'pointer',
                  fontFamily:  "'Poppins', sans-serif",
                  transition:  'all 150ms ease',
                  whiteSpace:  'nowrap',
                }}
                onMouseEnter={e => { if (!active) { e.currentTarget.style.borderColor = C.cyan; e.currentTarget.style.color = C.white; }}}
                onMouseLeave={e => { if (!active) { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.color = C.textDim; }}}
              >
                {label}
              </button>
            );
          })}
        </div>

        {/* Context-specific right content — always visible */}
        {right}
      </div>
    </header>
  );
}
